import { useRoute } from "vue-router";
import { useMainStore } from "../../pinia/main";
import { onMounted, reactive, getCurrentInstance } from "vue";
export default {
  name: "ProtocolManagementDetail",
  setup() {
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const route = useRoute();
    const data = reactive({
      messageId: 0,
      read: 0,
      info: {}
    });
    onMounted(() => {
      const {
        messageId,
        read
      } = route.query;
      data.messageId = messageId;
      data.read = read;
      getMessage();
    });

    //查询消息详情
    const getMessage = async () => {
      var res = await globalProperties.$api.getMessage(data.messageId);
      data.info = res;
      !Number(data.read) && readMessage();
    };
    const readMessage = async () => {
      await globalProperties.$api.readMessage(data.messageId);
    };
    return {
      data
    };
  }
};